import React, { useState, useEffect } from "react";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);

  const toggleVisibility = () => {
    const scrollTop = window.scrollY;
    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = (scrollTop / scrollHeight) * 100;
    setVisible(scrollTop > 300);
    setScrollPercent(scrolled);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const radius = 20;
  const stroke = 3;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset =
    circumference - (scrollPercent / 100) * circumference;

  return (
    visible && (
      <button
        onClick={scrollToTop}
        style={{
          position: "fixed",
          bottom: "40px",
          right: "30px",
          backgroundColor: "#203857",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          fontSize: "16px",
          cursor: "pointer",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
          zIndex: 1000,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
        }}
        aria-label="Back to Top"
      >
        {/* Circular Progress Ring */}
        <svg
          height={radius * 2}
          width={radius * 2}
          style={{
            position: "absolute",
            transform: "rotate(-90deg)",
          }}
        >
          <circle
            stroke="#F68633"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset,
              transition: "stroke-dashoffset 0.3s ease",
            }}
          />
        </svg>

        {/* Icon */}
        <i className="fa fa-arrow-up" aria-hidden="true"></i>
      </button>
    )
  );
};

export default BackToTop;
